// extracted by mini-css-extract-plugin
export var createdDate = "_lt-1";
export var divider = "_lt-2";
export var headerDivider = "_lt-3";
export var messagesCard = "_lt-0";
export var messagesContainer = "_lt-6";
export var messagesContainerWrapper = "_lt-4";
export var showLeftPanelButton = "_lt-8";
export var topButtons = "_lt-7";
export var withPadding = "_lt-5";